require('../../modules/es.string.includes');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'includes');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/string/includes.js
// module id = 1229
// module chunks = 1